import React from 'react';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      title: "Programming Languages",
      skills: ["JavaScript (ES6+)", "Java", "Python", "C++", "Go", "TypeScript", "SQL", "HTML5", "CSS3", "C", "R"]
    },
    {
      title: "Frontend Frameworks",
      skills: ["React", "Angular", "Vue.js", "Redux", "Next.js"]
    },
    {
      title: "CSS Frameworks",
      skills: ["Tailwind CSS", "Bootstrap", "Material-UI", "Styled Components"]
    },
    {
      title: "Backend Technologies",
      skills: ["Node.js", "Express.js", "REST APIs", "GraphQL", "Spring Boot", "Microservices"]
    },
    {
      title: "Databases",
      skills: ["PostgreSQL", "MongoDB", "MySQL", "Redis", "DynamoDB"]
    },
    {
      title: "Cloud Platforms",
      skills: ["AWS (EC2, S3, Lambda, RDS)", "Heroku", "ORACLE", "Google Cloud Platform"]
    },
    {
      title: "DevOps & Tools",
      skills: ["Docker", "Kubernetes", "Jenkins", "GitHub Actions", "Git", "Jira", "Figma"]
    },
    {
      title: "Testing Frameworks",
      skills: ["Jest", "Cypress", "Selenium", "Mocha", "Chai"]
    },
    {
      title: "Data & Analytics",
      skills: ["Power BI", "Tableau", "Google Analytics"]
    },
    {
      title: "Methodologies",
      skills: ["Agile/Scrum", "Test-Driven Development (TDD)", "CI/CD", "DevOps"]
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="skills-container">
        <div className="skills-header">
          <h2 className="skills-title">Technical Skills</h2>
          <p className="skills-subtitle">Technologies and tools I work with</p>
        </div>
        
        <div className="skills-grid">
          {skillCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="skill-category">
              <h3 className="category-title">{category.title}</h3>
              <div className="category-skills">
                {category.skills.map((skill, skillIndex) => (
                  <span key={skillIndex} className="skill-tag">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
